import React from 'react';
import { Chip as MuiChip, ChipProps as MuiChipProps } from '@mui/material';
import { StyledChip } from './Chip.style';

export interface ChipProps extends Omit<MuiChipProps, 'color'> {
  /**
   * The color of the chip
   */
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'warning' | 'info' | 'default' | 'unicityGreen' | 'unicityBlue' | 'unicityPurple' | 'unicityOrange' | 'unicityNavy';
  /**
   * The variant of the chip
   */
  variant?: 'filled' | 'outlined';
  /**
   * The size of the chip
   */
  size?: 'small' | 'medium';
  /**
   * Whether the chip is clickable
   */
  clickable?: boolean;
  /**
   * Whether the chip is deletable
   */
  deletable?: boolean;
  /**
   * The label of the chip
   */
  label: React.ReactNode;
  /**
   * Icon element placed before the label
   */
  icon?: React.ReactElement;
  /**
   * Icon element placed after the label (for delete)
   */
  deleteIcon?: React.ReactElement;
  /**
   * Callback fired when the delete icon is clicked
   */
  onDelete?: () => void;
  /**
   * Callback fired when the chip is clicked
   */
  onClick?: () => void;
}

export const Chip: React.FC<ChipProps> = ({
  color = 'default',
  variant = 'filled',
  size = 'medium',
  clickable = false,
  deletable = false,
  ...props
}) => {
  return (
    <StyledChip
      color={color}
      variant={variant}
      size={size}
      clickable={clickable}
      onDelete={deletable ? props.onDelete : undefined}
      {...props}
    />
  );
}; 